import { Preloader } from '@cian/preloader-component';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as styles from './FiltersSearchButton.css';

export interface IFiltersSearchButtonProps {
  href: string;
  title: string;
  text: string;
  dataMark: string;
  isLoading?: boolean;
  isLight?: boolean;
  onClick?(e: React.SyntheticEvent<HTMLElement>): void;
}

export function FiltersSearchButton({
  href,
  text,
  title,
  dataMark,
  isLight,
  isLoading,
  onClick,
}: IFiltersSearchButtonProps) {
  const loaderColor = isLight ? '#2b87db' : '#fff';

  return (
    <span className={styles['container']}>
      <a
        {...mergeStyles(styles['button'], isLoading && styles['button--loading'], isLight && styles['button--light'])}
        href={href}
        title={title}
        data-mark={dataMark}
        onClick={onClick}
      >
        {text}
        {isLoading && (
          <span className={styles['preloader']}>
            <Preloader size={18} stopColorForOffset0={loaderColor} stopColorForOffset1={loaderColor} />
          </span>
        )}
      </a>
    </span>
  );
}
